import React, {useState, useEffect} from 'react';
import {
    Tabs, TabList, TabPanels, Tab, TabPanel, Image, Box, Text, Flex, SimpleGrid, useDisclosure,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button
} from '@chakra-ui/react'
import { StyleSheet, css } from 'aphrodite';
// import { seminarDetails } from './SeminarDetails';
import { useSelector, useDispatch } from 'react-redux';
import { fetchData } from 'actions/actions';

function TTESeminar() {

    const { isOpen, onOpen, onClose } = useDisclosure();
    const [selectedSeminar, setSelectedSeminar] = useState(null);
    const dispatch = useDispatch();
    const data = useSelector(state=>state.data.data.seminar)

    const isMobile = useSelector(state=> state.windowSize.isMobile);

    useEffect(() => {
        // Dispatch the fetchData action when the component mounts
        dispatch(fetchData());
      }, [dispatch]); 

    console.log('TTE:', data)

    const handleSeminarClick = (seminarTitle) => {
        const foundSeminar = data?.find(seminar => seminar.title === seminarTitle);
        if (foundSeminar) {
            console.log("selectedSeminar updated:", foundSeminar);
          setSelectedSeminar(foundSeminar);
          onOpen();
        }
    };

    const parseEnglishDate = (dateStr) => {
        const d = new Date(dateStr);
        return Number.isNaN(d.getTime()) ? null : d;
    };

    const isFutureDate = (dateStr) => {
        const seminarDate = parseEnglishDate(dateStr);
        if (!seminarDate) return false;

        const today = new Date();
        seminarDate.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);

        return seminarDate >= today;
    };

  return (
    <>
    {data ? (
            <Box maxW="90%" mx="auto" pt={8} pb={12}>
    
                {/* Grid */}
                <SimpleGrid columns={isMobile ? 1 : 3} spacing={10} justifyContent="center">
                {data
                    ?.filter((seminar) => seminar.type === "TTE")
                    .slice()        // copy (do NOT mutate original)
                    .reverse()      // newest-added first
                    .map((content, index) => (
                    <Box
                        className={css(styles.card)}
                        onClick={() => handleSeminarClick(content.title)}
                        key={index}
                        cursor="pointer"
                    >
                        <Text className={css(styles.heading)} fontSize={20} color={isFutureDate(content.date) ? "red.500" : "black.600"}>
                        {content.title}
                        </Text>
    
                        {/* Date (red if future) + (upcoming) */}
                        <Text
                        className={css(styles.subtitle)}
                        color={isFutureDate(content.date) ? "red.500" : "gray.600"}
                        >
                        {content.date}
                        {isFutureDate(content.date) && (
                            <Text as="span" fontWeight="bold" ml={2}>
                            (upcoming)
                            </Text>
                        )}
                        </Text>
    
                        <Flex justifyContent="center">
                        <hr style={{ width: "50%", borderWidth: "2px" }} />
                        </Flex>
    
                        <Text className={css(styles.subtitle)}>
                        {content.address}
                        </Text>
    
                        {/* New last line */}
                        <Text
                        fontSize="sm"
                        mt={3}
                        textAlign="center"
                        color="blue.500"
                        fontStyle="italic"
                        >
                        Click for more information
                        </Text>
                    </Box>
                    ))}
                </SimpleGrid>
    
                {/* Empty state */}
                {data?.filter((seminar) => seminar.type === "TEM").length === 0 && (
                <Text textAlign="center" width="100%" fontWeight="bold" mt={8}>
                    Exciting Seminars Coming Soon, Stay Tuned!
                </Text>
                )}
            </Box>
            ) : (
            <Flex minH="50vh" align="center" justify="center">
                Loading...
            </Flex>
            )}
    
            {/* Modal (unchanged) */}
            <Modal isOpen={isOpen} onClose={onClose} isCentered size={"3xl"} allowPinchZoom>
            <ModalOverlay />
            <ModalContent>
                {selectedSeminar && (
                <>
                    <ModalHeader>About our host</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                    <Image
                        src={selectedSeminar.imageLink}
                        alt={selectedSeminar.title}
                        width="100%"
                    />
                    </ModalBody>
    
                    <ModalFooter>
                    <Button colorScheme="red" mr={3} onClick={onClose}>
                        Close
                    </Button>
                    </ModalFooter>
                </>
                )}
            </ModalContent>
            </Modal>
    </>
  )
};

const styles = StyleSheet.create({
    tabParent: {
        fontSize: 20,
        fontWeight: 'bold',
        color: '#DC242C'
    },
    heading: {
        fontWeight: 'bold',
        fontSize: '18',
        textAlign: 'center',
        marginTop: 5
    },
    subtitle: {
        fontSize: '20',
        textAlign: 'center',
        marginTop: 5,
        fontWeight: 'bold'
    },
    card: {
        borderWidth: '1px',
        borderRadius: '5px',
        borderColor: 'gray',
        justifyContent: 'center',
        textAlign: 'center',
        ':hover': {
          cursor: 'pointer'  
        },
        position: 'relative'
    },
    dateCircle: {
        position: 'absolute',
        bottom: 75,
        left: '50%', // Adjust as needed for positioning
        transform: 'translateX(-50%)',
        width: '10%',
        height: '10%',
        borderRadius: '50%',
        backgroundColor: 'black', // Change color as needed
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1, // Ensure the circle is above the image
      },
      dateText: {
        color: 'white',
        fontSize: '16',
        // fontWeight: 'bold',
        // Adjust text styles as needed
      },
})

export default TTESeminar